<div class="modal-overlay">
  <div class="otp-modal">
    <div *ngIf="loading" class="loading">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
    <div class="modal-head">
      <div class="title">
        {{ 'otp-modal.verify.title' | translate }}
      </div>
      <div class="close" (click)="onCancel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="modal-body">
      <div class="verify-wrapper otp-wrapper">
        <div class="sub-title">
          {{ 'otp-modal.verify.sub-title' | translate }}
        </div>
        <div class="send-via">
          <div class="email">{{ email }}</div>
        </div>
        <div class="otp-with-err-container">
          <div class="otp-input-container" [ngClass]="{'otp-shake': shakeOtp}">
            <app-otp-input [length]="6" (otpComplete)="onOtpEntered($event)" [errorState]="showError"></app-otp-input>
          </div>
          <div class="otp-error" *ngIf="showError">
            {{ errorMsg }}
          </div>
        </div>
        <button (click)="verifyOtp()" class="btn otp-btn" [ngClass]="{'verfiy-btn-disabled': !isOtpEntered}">
          {{ 'otp-modal.verify.verify-btn' | translate }}
        </button>
        <div class="resend-wrapper">
          <div class="title">{{ 'otp-modal.verify.resend-title' | translate }}</div>
          <div class="action" *ngIf="!pauseResending" (click)="resendOtp()">
            {{ 'otp-modal.verify.resend-action' | translate }}
          </div>
          <div *ngIf="pauseResending" class="timer">{{ formattedTime }}</div>
        </div>
      </div>
    </div>
  </div>
</div>


